import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithSalesOrderFormSectionType = {
  _initSalesOrder(salesOrder: string, client: string): void;
  _initSalesOrderValueChanges(
    getPreviousSelectedSalesOrder: () => string | null,
    getPreviousSelectedClient: () => string | null
  ): void;
  _buildSalesOrder(): string;
  _buildClient(): string;
};

type SalesOrderFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: {
    SPONSORED_SALES_ORDER: () => string;
    SPONSORED_CLIENT: () => string;
  };
  destroy$: Subject<boolean>;
};

export function WithSalesOrderFormSection<
  TBase extends Constructor<SalesOrderFormSectionRequerimentsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithSalesOrderFormSectionType;
  prototype: WithSalesOrderFormSectionType;
} & TBase {
  return class WithSalesOrderFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initSalesOrder(salesOrder: string, client: string): void {
      this.form
        .get(this.FORM_PATHS.SPONSORED_SALES_ORDER())
        .setValue(salesOrder);
      this.form.get(this.FORM_PATHS.SPONSORED_CLIENT()).setValue(client);
    }

    _initSalesOrderValueChanges(
      getPreviousSelectedSalesOrder: () => string | null,
      getPreviousSelectedClient: () => string | null
    ): void {
      this.form
        .get(this.FORM_PATHS.SPONSORED_SALES_ORDER())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousSelectedSalesOrder()) {
              this.form
                .get(this.FORM_PATHS.SPONSORED_SALES_ORDER())
                .markAsPristine();
            }
          },
        });

      this.form
        .get(this.FORM_PATHS.SPONSORED_CLIENT())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousSelectedClient()) {
              this.form
                .get(this.FORM_PATHS.SPONSORED_CLIENT())
                .markAsPristine();
            }
          },
        });
    }

    _buildSalesOrder(): string {
      return this.form.get(this.FORM_PATHS.SPONSORED_SALES_ORDER()).value;
    }

    _buildClient(): string {
      return this.form.get(this.FORM_PATHS.SPONSORED_CLIENT()).value;
    }
  };
}
